import {
    loginReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
 
} from "../reducers/onboarding/outbound.reducer"

import {
    createStoreProductReducer,
    uploadStoreBulkProductsReducer,
    updateStoreProductReducer,
    getProductMetaDataReducer,

    getImageGalleryReducer,
    uploadProductImageReducer,
    getImageReducer,
    downloadImageReducer,
    deleteImageReducer,
    updateProductImageReducer,

    getStoresListReducer,
    updateStoreReducer,
    getTopStoresReducer,
    getOrderListReducer,
    getOrderDetailsReducer,
    getProductsListReducer,
    getStoreDetailsReducer,
    getStoreTransactionsReducer,
    getCustomersReducer,
    getVendorsReducer,
    getVendorDetailsReducer,
    getStoreChartReducer,
    getAProductReducer,

    getDashboardSummaryReducer,
    getDashboardBottomOneReducer,
    getDashboardBottomTwoReducer,
    getVendorSummaryReducer,
    getProductsSummaryReducer,
    getACustomerAddressReducer,

    toggleUserReducer,
    toggleStoreReducer,

    addNewStoreReducer,
    getStoreCategoriesReducer,
    getStoreCategoryReducer,
    updateStoreCategoryReducer,
    createStoreCategoryReducer,
    updateStoreGroupReducer,
    getStoreGroupsReducer,
    getStoreGroupReducer,
    createStoreGroupReducer,
    deleteStoreCategoryReducer,
    deleteStoreGroupReducer,
    getUrlReducer,
    createVersionReducer,
} from "../reducers/inapp/inapp.reducer"



export const inAppReducers = {
    createStoreProductReducer,
    uploadStoreBulkProductsReducer,
    updateStoreProductReducer,
    getProductMetaDataReducer,

    getImageGalleryReducer,
    uploadProductImageReducer,
    updateProductImageReducer,
    getImageReducer,
    downloadImageReducer,
    deleteImageReducer,

    getStoresListReducer,
    getTopStoresReducer,
    getOrderListReducer,
    getOrderDetailsReducer,
    getProductsListReducer,
    getStoreDetailsReducer,
    getStoreTransactionsReducer,
    getCustomersReducer,
    getVendorsReducer,
    getVendorDetailsReducer,
    getStoreChartReducer,
    getAProductReducer,

    getDashboardSummaryReducer,
    getDashboardBottomOneReducer,
    getDashboardBottomTwoReducer,
    getVendorSummaryReducer,
    getProductsSummaryReducer,
    getACustomerAddressReducer,

    toggleUserReducer,
    toggleStoreReducer,

    addNewStoreReducer,
    getStoreCategoriesReducer,
    getStoreCategoryReducer,
    createStoreCategoryReducer,
    updateStoreCategoryReducer,
    deleteStoreCategoryReducer,
    getStoreGroupReducer,
    getStoreGroupsReducer,
    createStoreGroupReducer,
    updateStoreGroupReducer,
    deleteStoreGroupReducer,
    getUrlReducer,
    updateStoreReducer,
    createVersionReducer,

    // Blog reducers will be added when API is ready
}



export const outboundReducers = {
    loginReducer,
    forgotPasswordReducer,
    resetPasswordReducer,
   
}


